module.exports = __webpack_public_path__ + "media/images/svg/jumping-acrofit-03dfb62374940c6b4fdfebaf352ca12c.svg";